var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconImportAdsBlock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24.4375H32V7.5625H0V24.4375ZM11.3125 10.375C11.3125 10.0198 11.5139 9.6958 11.8306 9.53638C12.1475 9.37891 12.53 9.41187 12.812 9.62524L20.312 15.2502C20.5483 15.4268 20.6875 15.7051 20.6875 16C20.6875 16.2949 20.5483 16.5732 20.312 16.7498L12.812 22.3748C12.6472 22.4993 12.4495 22.5625 12.25 22.5625C12.1072 22.5625 11.9624 22.5295 11.8306 22.4636C11.5139 22.3042 11.3125 21.9802 11.3125 21.625V10.375Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 26.3125H22.5625V30.0625H16.9375V26.3125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 26.3125H15.0625V30.0625H9.4375V26.3125Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M29.1875 1.9375H24.4375V5.6875H32V4.75C32 3.19922 30.7383 1.9375 29.1875 1.9375Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.1875 12.25V19.75L18.1882 16L13.1875 12.25Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M9.4375 1.9375H15.0625V5.6875H9.4375V1.9375Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M0 27.25C0 28.8008 1.26172 30.0625 2.8125 30.0625H7.5625V26.3125H0V27.25Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M16.9375 1.9375H22.5625V5.6875H16.9375V1.9375Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M24.4375 30.0625H29.1875C30.7383 30.0625 32 28.8008 32 27.25V26.3125H24.4375V30.0625Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5625 1.9375H2.8125C1.26172 1.9375 0 3.19922 0 4.75V5.6875H7.5625V1.9375Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconImportAdsBlock);
export default __webpack_public_path__ + "static/media/ICON_IMPORT_ADS_BLOCK.02c61338eeab85f30d987092c61c65d0.svg";
export { ForwardRef as ReactComponent };